var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitch2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 27 27"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19813"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19812"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19161",
  transform: "translate(-158 -158.687)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  "data-name": "Ellipse 1584",
  transform: "translate(158 158.686)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-name": "Group 18473"
}, /*#__PURE__*/React.createElement("path", {
  d: "m174.483 179.259 2.6-2.6-2.68-2.68",
  "data-name": "Path 27068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.955 176.622h-7.2a4.29 4.29 0 0 1-4.287-4.288",
  "data-name": "Path 27069"
}), /*#__PURE__*/React.createElement("path", {
  d: "m169.028 164.518-2.6 2.6 2.675 2.68",
  "data-name": "Path 27070"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.636 167.16h7.2a4.29 4.29 0 0 1 4.289 4.288",
  "data-name": "Path 27071"
})))))));
export { SvgSwitch2 as ReactComponent };
export default __webpack_public_path__ + "static/media/switch2.4773f43e020244dafcb6af9985a4d865.svg";